import React, { ReactNode, forwardRef, memo } from "react";
import s from "../ComparisonTable.module.scss";
import cn from "classnames";
import { useHighlightedColumn } from "../ComparisonTable";
import { useHighlighting } from "../hooks/useHighlighting";

type HeaderProps = {
  children: ReactNode;
};

const Header = memo(forwardRef<HTMLDivElement, HeaderProps>(({ children }, ref) => {
  const highlightedColumn = useHighlightedColumn();
  const childrenCount = React.Children.count(children);
  const { getColumnProps } = useHighlighting(highlightedColumn, childrenCount);

  const childrenWithHighlight = React.Children.map(children, (child, index) => {
    if (React.isValidElement(child)) {
      const columnProps = getColumnProps(index);

      return React.cloneElement(
        child as React.ReactElement<{
          isHighlighted?: boolean;
          isBeforeHighlighted?: boolean;
          isAfterHighlighted?: boolean;
        }>,
        columnProps
      );
    }
    return child;
  });

  return (
    <div ref={ref} className={cn(s.header)} role="rowgroup">
      <div className={s.headerRow} role="row">
        <div
          className={cn(s.headerCell, s.headerCellEmpty, s.stickyShadow)}
          role="columnheader"
        />
        {childrenWithHighlight}
      </div>
    </div>
  );
}));

Header.displayName = "Header";

export default Header;
